import { newUuid } from "./uuid";

const KEY = "bg_anon_id";

function readStored(): string | null {
  try {
    return globalThis.localStorage?.getItem(KEY) ?? null;
  } catch {
    return null;
  }
}

function writeStored(id: string): void {
  try {
    globalThis.localStorage?.setItem(KEY, id);
  } catch {
    return;
  }
}

function removeStored(): void {
  try {
    globalThis.localStorage?.removeItem(KEY);
  } catch {
    return;
  }
}

/**
 * Anonymous analytics id, persisted under its own localStorage key `bg_anon_id`
 * (separate from the game save). Fail-safe: storage errors yield an ephemeral id
 * rather than throwing.
 */
export function getOrCreateAnonId(): string {
  const existing = readStored();
  if (existing) {
    return existing;
  }
  const id = newUuid();
  writeStored(id);
  return id;
}

/** Resets the anonymous id (a reset game counts as a new anonymous player). */
export function resetAnonId(): string {
  removeStored();
  return getOrCreateAnonId();
}
